<!-- <app-loader> -->
    <router-outlet></router-outlet>
<!-- </app-loader> -->